import React, { useState } from 'react';
import { BarometerChartComponent } from '../../components/WithNeedleChart';
import GridTable from '@nadavshaar/react-grid-table';
import "./styles.scss"
import ReactModal from 'react-modal';
import { TbFileExport } from "react-icons/tb";

export const gridTexts = { search: 'Pesquisar:', totalRows: 'Total de linhas:', rows: 'Linhas:', selected: 'Selecionados', rowsPerPage: 'Linhas por página:', page: 'Página:', of: 'de', prev: 'Anterior', next: 'Próxima', columnVisibility: 'Visibilidade da coluna' }

const BarometroDetailsScreen = () => {
  const [filter, setFilter] = useState()

  const ambiental = data.find(item => item.Nome === 'Sustentabilidade Ambiental')
  const economico = data.find(item => item.Nome === 'Sustentabilidade Economica')
  const social = data.find(item => item.Nome === 'Sustentabilidade Social')
  const geral = data.find(item => item.Nome === 'Sustentabilidade Geral')

  return <div className='barometer-details'>
    <div className='bar-header'>
      <div>
        <BarometerChartComponent value={(geral?.Indice) * 100} width={600} height={600} label={parseFloat(geral?.Indice).toFixed(1)} />
      </div>
      <div className='user-details'>
        <h1>{"Everton Bernardes"}</h1>
        <span className='field-email'>{"everton.tec@manejebem.com"}</span>
        <div className='date-tab'>
          <span className='field-date'>{"01/01/2023"}</span>
          {/* <span className='field-date active'>{"01/03/2023"}</span> */}
          <div style={{flex: 1}}/>
          <div className={`icon-container`} onClick={() => { }}>
            <TbFileExport className="icon-filter" />
            <text className="text-filter">Exportar</text>
          </div>
        </div>
        
        <div className='indice-container'>
          <div className='indice' onClick={() => setFilter(filter !== 'Social' && 'Social')}>
            <div>Social</div>
            <span>{parseFloat(social?.Indice).toFixed(1)}</span>
            <div>{social?.Conceito}</div>
          </div>
          <div className='indice' onClick={() => setFilter(filter !== 'Ambiental' && 'Ambiental')}>
            <div>Ambiental</div>
            <span>{parseFloat(ambiental?.Indice).toFixed(1)}</span>
            <div>{ambiental?.Conceito}</div>
          </div>
          <div className='indice' onClick={() => setFilter(filter !== 'Economico' && 'Economico')}>
            <div>Econômico</div>
            <span>{parseFloat(economico?.Indice).toFixed(1)}</span>
            <div>{economico?.Conceito}</div>
          </div>
        </div>
      </div>
    </div>
    <div className='barometer-body'>
      <GridTable texts={gridTexts} columns={columns} rows={data.filter(item => !filter || item.Dimensao === filter)} />
    </div>
  </div>
}

const recommendData = [
  { id: 1, desc: "Reflorestamento de bordas de mananciais (plantio total)", impacto: "Alto", custoimpl: "Alto", customanu: "Alto", prazo: "Médio" },
  { id: 2, desc: "Cercamento da área e abandono", impacto: "Alto", custoimpl: "Alto", customanu: "Alto", prazo: "Médio" },
  { id: 3, desc: "Isolamento e condução das espécies regenerantes", impacto: "Alto", custoimpl: "Médio", customanu: "Médio", prazo: "Longo" },
  { id: 4, desc: "Implantação de SAF Biodiverso (pequeno produtor)", impacto: "Alto", custoimpl: "Alto", customanu: "Alto", prazo: "Médio" },
  { id: 5, desc: "Apenas abandono (delimitação)", impacto: "Alto", custoimpl: "Baixo", customanu: "Baixo", prazo: "Longo" },
]

const recommendColumns = [
  {
    id: "checkbox"
  },
  {
    id: 1,
    field: 'id',
    label: 'id',
    width: '40px'
    // cellRenderer: Username,
  },
  {
    id: 2,
    field: 'desc',
    label: 'Recomendação',
    width: '400px'
  },
  {
    id: 3,
    field: 'custoimpl',
    label: 'Custo de Implantação',
    width: '200px',
    cellRenderer: ({ value }) => <div className='rgt-cell-inner rgt-text-truncate' style={{ color: getColor2(value) }}>{value}</div>
  },
  {
    id: 4,
    field: 'customanu',
    label: 'Custo de Manutenção',
    width: '200px',
    cellRenderer: ({ value }) => <div className='rgt-cell-inner rgt-text-truncate' style={{ color: getColor2(value) }}>{value}</div>
  },
  {
    id: 5,
    field: 'prazo',
    label: 'Prazo',
    width: '200px',
    cellRenderer: ({ value }) => <div className='rgt-cell-inner rgt-text-truncate' style={{ color: getColor2(value) }}>{value}</div>
  },
]

const getColor = (value) => {
  if (["Otimo", "Nao"].includes(value)) {
    return "#6aaa73"//verde escuro
  } else if (["Bom", 'Alto'].includes(value)) {
    return "#d5e370"//verde claro
  } else if (['Intermediario', 'Medio', 'Médio'].includes(value)) {
    return "#f7c648"//amarelo
  } else if (["Baixo"].includes(value)) {
    return "#ef825d"//laranja
  } else if (["Ruim", "Sim", 'Longo'].includes(value)) {
    return "#c65c5e"//vermelho
  }
}

const getColor2 = (value) => {
  if (["Otimo", "Nao", "Baixo"].includes(value)) {
    return "#6aaa73"//verde escuro
  } else if (["Bom"].includes(value)) {
    return "#d5e370"//verde claro
  } else if (['Intermediario', 'Medio', 'Médio'].includes(value)) {
    return "#f7c648"//amarelo
  } else if ([""].includes(value)) {
    return "#ef825d"//laranja
  } else if (["Ruim", "Sim", 'Longo', 'Alto'].includes(value)) {
    return "#c65c5e"//vermelho
  }
}

// { id: 0, position: "INSIDE", text: 'Ruim', color: "white", bgColor: '#c65c5e', value: 20 },
//   { id: 1, position: "INSIDE", text: 'Pobre', color: "white",bgColor: '#ef825d', value: 20 },
//   { id: 2, position: "INSIDE", text: 'Intermédiário', color: "white",bgColor: '#f7c648', value: 20 },
//   { id: 3, position: "INSIDE", text: 'Bom', color: "white",bgColor: '#d5e370', value: 20 },
//   { id: 4, position: "INSIDE", text: 'Ótimo', color: "white",bgColor: '#6aaa73', value: 20 },

const RecommendModal = () => {
  const [open, setOpen] = useState(false);
  const [selecteds, setSelecteds] = useState([]);

  return <>
    <div className='recommend' onClick={() => setOpen(true)}><div>Ver </div><div style={{ color: "#f45100" }}>{selecteds.length > 0 ? `${selecteds.length} Selecionada(s)` : ''}</div></div>
    <ReactModal
      isOpen={open}
      className='body-recommend'
      onRequestClose={() => setOpen(false)}
    >
      <div>
        <GridTable onSelectedRowsChange={setSelecteds} isPaginated={false} texts={gridTexts} columns={recommendColumns} rows={recommendData} />
      </div>
    </ReactModal>
  </>
}

const columns = [
  {
    id: 1,
    field: 'Nome',
    label: 'Nome',
    width: '400px'
    // cellRenderer: Username,
  },
  {
    id: 2,
    field: 'Dimensao',
    label: 'Dimensao',
  },
  {
    id: 3,
    field: 'Etapa',
    label: 'Etapa',
  },
  {
    id: 4,
    field: 'Conceito',
    label: 'Conceito',
    cellRenderer: ({ value }) => <div className='rgt-cell-inner rgt-text-truncate' style={{ color: getColor(value) }}>{value}</div>
  },
  {
    id: 5,
    field: 'Indice',
    label: 'Indice',
    cellRenderer: ({ value }) => <div>{parseFloat(value).toFixed(2)}</div>
  },
  {
    id: 6,
    field: 'recommend',
    label: 'Recomendação',
    cellRenderer: () => <RecommendModal />
  }
];

const data = [
  { 'Nome': 'CoberturaAPP', 'Dimensao': 'Ambiental', 'Etapa': 'Cobertura Vegetal', 'Conceito': 'Bom', 'Indice': '101.0' },
  { 'Nome': 'FlorestaNativa', 'Dimensao': 'Ambiental', 'Etapa': 'Cobertura Vegetal', 'Conceito': 'Otimo', 'Indice': '100.0' },
  { 'Nome': 'FocosCalor', 'Dimensao': 'Ambiental', 'Etapa': 'Cobertura Vegetal', 'Conceito': 'Otimo', 'Indice': '0.0' },
  { 'Nome': 'FormacaoNovasAreas', 'Dimensao': 'Ambiental', 'Etapa': 'Cobertura Vegetal', 'Conceito': 'Otimo', 'Indice': '2.0' },
  { 'Nome': 'ICV', 'Dimensao': 'Ambiental', 'Etapa': 'Cobertura Vegetal', 'Conceito': 'Alto', 'Indice': '8.182102289384082' },
  { 'Nome': 'Caça', 'Dimensao': 'Ambiental', 'Etapa': 'Biodiversidade Agua', 'Conceito': 'Nao', 'Indice': '1.0' },
  { 'Nome': 'InsumosCorposAgua', 'Dimensao': 'Ambiental', 'Etapa': 'Biodiversidade Agua', 'Conceito': 'Sim', 'Indice': '0.0' },
  { 'Nome': 'IBCA', 'Dimensao': 'Ambiental', 'Etapa': 'Biodiversidade Agua', 'Conceito': 'Baixo', 'Indice': '1.8018740629685275' },
  { 'Nome': 'Saneamento', 'Dimensao': 'Ambiental', 'Etapa': 'Residuos', 'Conceito': 'Otimo', 'Indice': '100.0' },
  { 'Nome': 'Lixo', 'Dimensao': 'Ambiental', 'Etapa': 'Residuos', 'Conceito': 'Intermediario', 'Indice': '50.0' },
  { 'Nome': 'IR', 'Dimensao': 'Ambiental', 'Etapa': 'Residuos', 'Conceito': 'Medio', 'Indice': '5.0333333333333306' },
  { 'Nome': 'Tipo', 'Dimensao': 'Ambiental', 'Etapa': 'Manejo', 'Conceito': 'Otimo', 'Indice': '100.0' },
  { 'Nome': 'Cultivo', 'Dimensao': 'Ambiental', 'Etapa': 'Manejo', 'Conceito': 'Otimo', 'Indice': '100.0' },
  { 'Nome': 'Secagem', 'Dimensao': 'Ambiental', 'Etapa': 'Manejo', 'Conceito': 'Ruim', 'Indice': '0.0' },
  { 'Nome': 'IM', 'Dimensao': 'Ambiental', 'Etapa': 'Manejo', 'Conceito': 'Baixo', 'Indice': '1.8018740629685275' },
  { 'Nome': 'Sustentabilidade Ambiental', 'Dimensao': 'Ambiental', 'Etapa': 'Ambiental', 'Conceito': 'Baixo', 'Indice': '2.0822620142484802' },
  { 'Nome': 'EscolaridadeCF', 'Dimensao': 'Social', 'Etapa': 'Educacao', 'Conceito': 'Bom', 'Indice': '60.0' },
  { 'Nome': 'Capacitou', 'Dimensao': 'Social', 'Etapa': 'Educacao', 'Conceito': 'Otimo', 'Indice': '1.0' },
  { 'Nome': 'IE', 'Dimensao': 'Social', 'Etapa': 'Educacao', 'Conceito': 'Alto', 'Indice': '7.897690447400156' },
  { 'Nome': 'Jovens', 'Dimensao': 'Social', 'Etapa': 'Inclusao', 'Conceito': 'Bom', 'Indice': '70.0' },
  { 'Nome': 'Mulheres', 'Dimensao': 'Social', 'Etapa': 'Inclusao', 'Conceito': 'Otimo', 'Indice': '100.0' },
  { 'Nome': 'II', 'Dimensao': 'Social', 'Etapa': 'Inclusao', 'Conceito': 'Medio', 'Indice': '5.0333333333333306' },
  { 'Nome': 'Moradia', 'Dimensao': 'Social', 'Etapa': 'Habitacao', 'Conceito': 'Otimo', 'Indice': '80.0' },
  { 'Nome': 'Energia', 'Dimensao': 'Social', 'Etapa': 'Habitacao', 'Conceito': 'Ruim', 'Indice': '0.0' },
  { 'Nome': 'Densidade', 'Dimensao': 'Social', 'Etapa': 'Habitacao', 'Conceito': 'Intermediario', 'Indice': '3.0' },
  { 'Nome': 'IH', 'Dimensao': 'Social', 'Etapa': 'Habitacao', 'Conceito': 'Medio', 'Indice': '4.490598720501793' },
  { 'Nome': 'SAUDE', 'Dimensao': 'Social', 'Etapa': 'Saude', 'Conceito': 'Otimo', 'Indice': '100.0' },
  { 'Nome': 'Sustentabilidade Social', 'Dimensao': 'Social', 'Etapa': 'Saude', 'Conceito': 'Alto', 'Indice': '7.44368047564356' },
  { 'Nome': 'RendaProducao', 'Dimensao': 'Economico', 'Etapa': 'Renda familiar', 'Conceito': 'Otimo', 'Indice': '212.0' },
  { 'Nome': 'DependenciaCacau', 'Dimensao': 'Economico', 'Etapa': 'Renda familiar', 'Conceito': 'Baixo', 'Indice': '41.0' },
  { 'Nome': 'IRF', 'Dimensao': 'Economico', 'Etapa': 'Renda familiar', 'Conceito': 'Alto', 'Indice': '8.206946564885403' },
  { 'Nome': 'ATER', 'Dimensao': 'Economico', 'Etapa': 'Gestao', 'Conceito': 'Intermediario', 'Indice': '40.0' },
  { 'Nome': 'InsumosExternos', 'Dimensao': 'Economico', 'Etapa': 'Gestao', 'Conceito': 'Intermediario', 'Indice': '27.0' },
  { 'Nome': 'Comercializacao', 'Dimensao': 'Economico', 'Etapa': 'Gestao', 'Conceito': 'Otimo', 'Indice': '100.0' },
  { 'Nome': 'IG', 'Dimensao': 'Economico', 'Etapa': 'Gestao', 'Conceito': 'Medio', 'Indice': '5.29902112351842' },
  { 'Nome': 'Produtividade', 'Dimensao': 'Economico', 'Etapa': 'Economico', 'Conceito': 'Medio', 'Indice': '32.0' },
  { 'Nome': 'Sustentabilidade Economica', 'Dimensao': 'Economico', 'Etapa': 'Economico', 'Conceito': 'Medio', 'Indice': '5.206804887820868' },
  { 'Nome': 'Sustentabilidade Geral', 'Dimensao': 'Sustentabilidade', 'Etapa': 'Geral', 'Conceito': 'Medio', 'Indice': '5.163941012766738' },
]

export default BarometroDetailsScreen;